import { memo } from 'react';
import { LoadingContent } from 'Elements';

export const LoadingAuthentication = memo(() => {
	return <LoadingContent full title="title.authentication-in-progress" />;
});

LoadingAuthentication.displayName = 'LoadingAuthentication';
